import React, { Component, Fragment } from "react";
import { findDOMNode } from 'react-dom';
import ReactPlayer from 'react-player';
import moment from 'moment';
import screenfull from 'screenfull';
import Duration from './parts/duration';
import {isMobile} from 'react-device-detect';

import "./player.css";

require('moment/min/locales');
moment.locale('it')

var qs = require('qs');

var userId
var contentId
var content
var image
const dateFormat = "dddd DD MMMM YYYY - HH:mm"
const playIcon = "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/playIcon.svg";
const pauseIcon = "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/pauseIcon.svg"


class Player extends React.Component{

  constructor(props) {
    super(props)
    this.state = {
      playing: false,
      duration: 0,
      currentProgress: 0,
      currentSeconds: 0,
      opacity: true,
      mouseMoving: false,
      userId: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).userId,
      idContent: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).idContent,
      currentContent: {},
      imgUser: ""
    }
    this.setMouseMove = this.setMouseMove.bind(this);
  }
    componentWillMount(){
        fetch("https://api.peperoni.ai/core/pep-core/user/" + this.state.userId)
          .then(response => response.json())
          .then(data => this.setState({imgUser: data.results.avatar}))
        fetch("https://api.peperoni.ai/contents/pep-contents/"+ this.state.userId + "/content/" + this.state.idContent)
          .then(response => response.json())
          .then(data => this.setState({currentContent: data.content}))
    }

    handlePlay = () =>{
      this.setState({playing: !this.state.playing}) 
    }

    handleDuration = (duration) =>{
      //console.log('onDuration', duration);
      this.setState({duration: duration});
    }

    handleProgress = state => {
      this.setState({currentProgress: state.played * 100, currentSeconds:state.playedSeconds});
    }

    handleFullscreen = () => {
      screenfull.toggle(findDOMNode(this.containerPlayer))
    }

    changeTime = (e) => {
      this.setState({playing: false})
      var value = (this.state.duration * e.target.value) / 100;
      this.player.seekTo(parseFloat(value));
      this.setState({playing: true})
    }

    setMouseMove(e) {
      e.preventDefault();
      this.setState({mouseMoving: true});
      console.log(e)
      let timeout;
      (() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => this.setState({mouseMoving:false}), 5000);
      })();
    }

    prev10 = () =>{
      if(this.state.currentSeconds > 10) {
        this.setState({playing: false})
        this.player.seekTo(parseFloat(this.state.currentSeconds - 10))
        this.setState({playing: true})
      } else {
        this.setState({playing: false})
        this.player.seekTo(parseFloat(0))
        this.setState({playing: true})
      }
    }

    next10 = () =>{
      if(this.state.currentSeconds + 10 < this.state.duration) {
        this.setState({playing: false})
        this.player.seekTo(parseFloat(this.state.currentSeconds + 10))
        this.setState({playing: true})
      } else {
        this.setState({playing: false})
        this.player.seekTo(this.state.duration)
        this.setState({playing: true})
      }
    }

    setOpacity = () =>{
      this.setState({opacity: !this.state.opacity})
    }

    ref = containerPlayer => {
      this.containerPlayer = containerPlayer 
    }

    ref = player => {
      this.player = player
    }



    render(){
        //console.log(this.state);
        const scrollButtonStyle = {
          visibility: this.state.mouseMoving ? 'visible': 'hidden', 
         };
         const opacity = {
           opacity: this.state.opacity ? '1' : '0'
         }
        var currentContent = this.state.currentContent;
        if(currentContent !== undefined && currentContent.img_url !== undefined && currentContent.img_url !== null){
          image = currentContent.img_url;
        } else {
          if(this.state.imgUser !== null) {
            image = this.state.imgUser
          } else {
            image = "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/user_icon.png"
          }
        }
        
        return(
            <div className="main" >
              <div ref={this.containerPlayer}>
                { currentContent !== undefined && currentContent.video_url !== null ? (
                      <div className="fullScreenMobile">
                        <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/fullscreen-icon.png" onClick={this.handleFullscreen} />
                      </div>
                    ) : (
                      ""
                    )
                }
                <ReactPlayer
                  ref={this.ref}
                  className={ currentContent !== undefined && currentContent.video_url !== null ? 'playerVideo' : 'playerAudio'}  
                  url={ currentContent !== undefined && currentContent.video_url !== null ? currentContent.video_url : currentContent.audio_url} 
                  playing={this.state.playing} 
                  onDuration={this.handleDuration}
                  onProgress={this.handleProgress}
                  onClick={this.setOpacity}
                  controls={isMobile && currentContent.video_url !== null ? true : false}
                />
              </div>
              <div style={opacity} className={currentContent.video_url !== null ? 'containerContent video' : 'containerContent audio'}>
                <div className="overlayVideo" onClick={this.setOpacity} ></div>
                <div className="controls">
                  <div className={currentContent.video_url !== null ? 'coverVideo' : 'coverAudio'}>
                    <img  src={image} onClick={this.handlePlay} />
                    <div className="overlayImage">
                      <img className="playIcon" src={this.state.playing ? pauseIcon : playIcon} onClick={this.handlePlay} />
                    </div>
                  </div>
                </div>
                <div className="mobileSection">
                  <div className={currentContent.video_url !== null ? 'cover-video' : 'cover'}>
                    <img  src={image} onClick={this.handlePlay} />
                  </div>
                  <div className={currentContent.video_url !== null ? 'meta-video' : 'meta'}>
                    <div className="prevIcon">
                      <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/prev10.png" onClick={this.prev10} />
                    </div>
                    <div className="playContent">
                      <img className="playIcon" src={this.state.playing ? pauseIcon : playIcon} onClick={this.handlePlay} />
                    </div>
                    <div className="nextIcon">
                      <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/next10.png" onClick={this.next10} />
                    </div>
                  </div>
                  <div className={currentContent.video_url !== null ? 'controlsMobile video' : 'controlsMobile'}>
                    <h2 className="dateContent">{moment(currentContent.created_at).format(dateFormat)}</h2>
                    <h1 className="titleContent">{currentContent.title}</h1>
                    <p className="descriptionContent">{currentContent.description}</p>
                    {/* <input type="range" min="0" max="100" value={this.state.currentProgress} className="timeScroll" onInput={((e) => this.changeTime(e))} onChange={((e) => this.changeTime(e))} ></input>
                    <p className="timeStart">
                      <Duration seconds={this.state.currentSeconds} />
                    </p>
                    <p className="timeEnd">
                      <Duration seconds={this.state.duration} />
                    </p> */}
                  </div>
                  
                </div>
                <div className="controlBottom">
                  <div className="controlPlayer">
                    <input type="range" min="0" max="100" value={this.state.currentProgress} className="timeScroll" onInput={((e) => this.changeTime(e))} onChange={((e) => this.changeTime(e))} ></input>
                    <p className="timeEnd">
                      - <Duration seconds={this.state.duration - this.state.currentSeconds} />
                    </p>
                  </div>
                  <div className="playContent">
                    <img className="playIcon" src={this.state.playing ? pauseIcon : playIcon} onClick={this.handlePlay} />
                  </div>
                  <div className="timeController">
                    <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/prev10.png" onClick={this.prev10} />
                    <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/next10.png" onClick={this.next10} />
                  </div>
                  { currentContent.video_url !== null ? (
                      <div className="rightController">
                        <img src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/fullscreen-icon.png" onClick={this.handleFullscreen} />
                      </div>
                    ) : (
                      ""
                    )
                  }
                </div>
                <div className="data">
                  <h2 className="dateContent">{moment(currentContent.created_at).format(dateFormat)}</h2>
                  <h1 className="titleContent">{currentContent.title}</h1>
                  <p className="descriptionContent">{currentContent.description}</p>
                </div>
              </div>
            </div>
              
        )
    }
}


export default Player